/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import env from 'src/config/vars.config';

export const sendMatchRules = async formData => {
  const response = await axios.post(env.matchRulesUrl, formData, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return response.data;
};

export const sendBusinessCase = async (formData, config = {}) => {
  const response = await axios.post(env.businessCaseUrl, formData, {
    headers: { 'Content-Type': 'application/json' },
    ...config
  });
  return response.data;
};

export const sendSlackNotification = async attachment => {
  const formData = new FormData();

  // If it's a Blob but not a File, wrap it
  let fileAttachment = attachment;
  if (attachment instanceof Blob && !(attachment instanceof File)) {
    fileAttachment = new File([attachment], 'document.pdf', {
      type: 'application/pdf'
    });
  }

  formData.append('attachment', fileAttachment); // backend expects "file"

  const response = await axios.post(env.slackNotificationsUrl, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return response.data;
};
